import React from "react";
import toast from "react-hot-toast";
import useApi from "../useApi";

export type Clinic = {
  clinicName: string;
  billablePatientCount: number;
  status: string;
  revenue?: string;
};

type BillablePatientData = {
  billablePatientList: Clinic[];
};

type BillablePatientResponse = {
  status: string;
  data: BillablePatientData;
};

const useBillablePatients = () => {
  const [billablePatients, setBillablePatients] = React.useState<Clinic[] | undefined>();

  const { loading: billablePatientsLoading, makeApiCall } = useApi({
    url: `/rtm/dashboard/patient/billable`,
    method: "GET",
  });

  const getBillablePatients = async () => {
    const { response, error } = await makeApiCall<undefined, BillablePatientResponse>();

    if (response?.status === "success") {
      setBillablePatients(response.data.billablePatientList);
    }

    if (!response?.status) {
      setBillablePatients(undefined);
    }

    if (error) {
      toast.error("Failed to fetch billable patients data. Please try again later.");
    }
  };

  return {
    billablePatients,
    getBillablePatients,
    billablePatientsLoading,
  };
};

export default useBillablePatients;